(function () {
  // Love Loyalty's referral-claim popup ineligibility error has no
  // matching key anywhere in the app's own translation settings (checked
  // directly in the app admin) — every other string on this popup is
  // covered there, just not this one. Plain text swap for this single
  // string only.
  var ERROR_MAP = {
    'Not eligible for referral reward.': 'Ten link polecający nie kwalifikuje się do odebrania nagrody.'
  };

  function translate(el) {
    var current = el.textContent.trim();
    var translated = ERROR_MAP[current];
    if (translated && current !== translated) el.textContent = translated;
  }

  function scan(root) {
    root.querySelectorAll('.ll__page-referral .ll__referral-error').forEach(translate);
  }

  function init() {
    scan(document);
    new MutationObserver(function () {
      scan(document);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
